<template>
  <b-modal
    id="mobile-how-modal"
    v-model="show" 
    ok-only 
    centered 
    size="lg" 
    footer-class="border-top d-none d-sm-block"
    header-class="d-none d-sm-block"
    :ok-title="hebrew ? 'סגור' : 'Close'"
    ok-variant="secondary"
    >
    <template slot="modal-header">{{hebrew ? 'איך זה עובד' : 'How it works'}}</template>
    <div class="mobile-modal-top bg-secondary position-fixed w-100 d-block d-sm-none">
      <div class="row">
        <div class="col-8">
          <h3>{{hebrew ? 'איך זה עובד' : 'How it works'}}</h3>
        </div>
        <div @click="show=false" class="close-icon col-4" v-bind:class="{'text-left': hebrew, 'text-right': !hebrew}">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>    
    <div class="how-to-text pl-3" v-if="hebrew">
      <p>
        הכלי לניתוח מורפולוגי נועד להציג את המאפיינים המורפולוגיים של כל מילה בטקסט. הורדת קובץ Excel תאפשר לכם לערוך מניפולציות על הניתוח המורפולוגי כרצונכם.      
      </p>
      <p>
        בתחילת העבודה תוכלו לבחור בין הזנת טקסט באופן ידני להעלאת קובץ יחיד או קובצי טקסט (מסוג .txt).
      </p>      
      <h3 class="text-underline">סגנון טקסט</h3>
      <p>
ברירת המחדל היא "טקסט מודרני". אם הטקסט שמוזן במערכת מוקדם יותר - יש להגדיר את סגנון הטקסט בצד שמאל של המסך.      </p>
      <h3 class="text-underline">הצגת התוצאות</h3>
      <p>
בלחיצה על הכפתור ״החל ניתוח מורפולוגי״, יוצגו התוצאות.
      </p>
      <p>
בתצוגה המקדימה באתר יוצגו מאה שורות מתוך הטקסט. לתצוגה המלאה יש להוריד קובץ.      
      </p>
      <p>
בצד שמאל, בשורת התוצאות, תוכלו לבחור בין תצוגת הנתונים בפורמט BGU ל-UD.
      </p>    
      <h3 class="text-underline">עבודה עם קבצים גדולים וקבצי Zip</h3>
      <p>
אם העלתם טקסט ארוך, מספר קובצי טקסט או קובץ zip (שכולל קבצי .txt בלבד), העבודה עשויה לערוך זמן. במצב כזה, תידרשו להזין את כתובת הדוא"ל שלכם לאחר העלאת הקובץ או הקבצים. בסיום העבודה על הניתוח המורפולוגי יישלח אליכם דוא״ל שיכלול קישור להורדת קובץ Excel.     
     </p>  
      <p><strong>חשוב! כדי לקבל ניתוח מדוייק, מומלץ להזין טקסט מנוקד.</strong></p>
      <p>אם טרם ניקדתם את הטקסט שלכם, אתם מוזמנים לעשות זאת באמצעות 
      <a href="https://nakdan.dicta.org.il/" target="_blank">הנקדן שלנו</a>
      .</p>
    </div>
    <div v-else class="how-to-text pr-3">
      <p>
        The Morphological Analysis tool analyzes and displays the morphological values of each word in a given text. After the analysis is complete, an editable Excel file is generated with the full analysis results.
      </p>
      <p>
        The tool supports inputted text or text file uploads.
      </p>
      <h3 class="text-underline">
        Text Style
      </h3>
      <p>
        The default text style of the tool is Modern Hebrew text. The text style can be set on the right side of the main page.
      </p>
      <h3 class="text-underline">
        Results Display
      </h3>
      <p>
        After clicking on the “Morphological Analysis” button, a preview of the first 100 results is displayed.
      </p>
      <p>
        Click on the “Download” button to download and view the complete analysis.
      </p>
      <p>
        The result file can be downloaded in BGU and UD formats.
      </p>
      <h3 class="text-underline">
        Processing large/Zip files
      </h3>
      <p>
        After uploading a large .txt file or a Zip file containing several .txt files you will be required to enter your email address. Once the morphological analysis is complete, you will receive an email with link(s) for downloadable Excel file(s) containing your results. Large amounts of data will require a longer processing time.
      </p>
      <p><strong>
        For accurate results, it is important to submit text with nikud.
      </strong></p>
      <p>Use Dicta’s  <a href="https://nakdan.dicta.org.il/" target="_blank">Nakdan</a> tool to add nikud to your text.</p>        
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "about-dialog",
  props: ["value"],
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }, 
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
<style lang="scss">
  @media screen and (max-width: 767px) {
    #mobile-how-modal{
      -webkit-overflow-scrolling: touch;
      direction: ltr;
      text-align: left;
      .modal-dialog {
        margin: 0!important;
      }
      .modal-content {
        border-radius: 0!important;
        height: 100vh;
        overflow-y: scroll;
        overflow-x:hidden;
        background:white;
      }
      .mobile-modal-top{
          height: 50px;
          top:0;
          right:0;
          padding:15px;
          z-index: 1;
          h3{text-decoration:none;}
      }
      .how-to-text{
          padding-top:50px;
          max-height: 88vh;
          overflow-y: scroll;
          overflow-x:hidden;
      }
      @media screen and (max-width: 667px) {
        .how-to-text{
          max-height: 83vh;
        }
      }      
    }
    .he #mobile-how-modal {
      text-align: right;
      direction: rtl;
    }
  }
</style>
<style scoped>
.how-to-text {
  max-height: 70vh;
  overflow: auto;
}
</style>
